import React from 'react';
import s from './FaqV2.scss';

const FaqV2 = props => {
  const { items, data } = props;
  if (!(Array.isArray(items) && items.length > 0)) {
    return null;
  }
  return (
    <div className={s.qnawrapper}>
      <h2>{data && data.name ? data.name : 'FAQs'}</h2>
      <div className={s.qnacontent}>
        {items.map(item => (
          <div className={s.qnaitem}>
            <h3 className={s.qnaquestion}>{item.hl}</h3>
            <div className={s.qnaanswer}>{item.des}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqV2;
